import BarChartWidgetRenderService from '@/modules/ta/legacy/widget/services/types/BarChartWidgetRenderService';

export class LegacyBarChartWidgetRenderService extends BarChartWidgetRenderService {
  /**
   * @var Widget
   */
  _widget;

  /**
   * @var array
   */
  _chartPalette;

  /**
   * @var boolean
   */
  _hasComparisonData;

  /**
   * @var boolean
   */
  _isExporting;

  /**
   * @var string
   */
  _backgroundColor;

  constructor(
    widget,
    chartPalette = [],
    hasComparisonData = false,
    isExporting = false,
    backgroundColor = null
  ) {
    super(widget.id);
    this._widget = widget;
    this._chartPalette = chartPalette;
    this._hasComparisonData = hasComparisonData;
    this._isExporting = isExporting;
    this._backgroundColor = backgroundColor;
  }

  getWidget() {
    return this._widget;
  }

  /**
   * @returns {boolean}
   */
  isExporting() {
    return this._isExporting;
  }

  getFullChartPalette() {
    return this._chartPalette;
  }

  /**
   * @param columnIndex
   * @returns {string}
   */
  getChartPalette(columnIndex) {
    return this._chartPalette[columnIndex % this._chartPalette.length];
  }

  getChartConfigProperties() {
    return {
      ...super.getChartConfigProperties(),
      hoverColor: this.getChartPalette(0),
    };
  }

  hasComparison() {
    return this._hasComparisonData;
  }
}
